import { ToneMappingEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const ToneMapping = wrapEffect(ToneMappingEffect)
